import platform from '@propertypal/shared/src/utils/platform';

export const NO_REFRESH_ADVERTISERS: number[] = [
  4758324707, // Amazon
];
export const NO_REFRESH_YIELD_GROUPS: number[] = [];

const rubiconParams = {
  accountId: 15656,
  siteId: platform.select(102986, 558352),
  zoneId: platform.select(483906, 4105879),
};

const unrulyParams = {
  siteId: 258192,
};

export const liveRampParams = {
  placementId: '13953',
};

type OguryParams = {
  assetKey: string;
  adUnitIds: Record<string, string>;
};

const oguryParams: OguryParams = {
  assetKey: platform.select('OGY-645F167ED3C7', 'OGY-78B666A3162E'),
  adUnitIds: {
    PDPmap: platform.select('wm-hb-stdb-proper-prope-cqw6zwjuxlka', 'wm-hb-stdb-proper-prope-ynnoaugnp0zl'),
    PDPmediabox: platform.select('wm-hb-stdb-proper-prope-slaiwy8o524h', 'wm-hb-stdb-proper-prope-ftwg7bsntpm6'),
    PDPmiddle_desktop: platform.select('wd-hb-stdb-proper-prope-rxj0e0jqps6q', 'wd-hb-stdb-proper-prope-ihrqnxrakihh'),
    PDPmiddle_mobile: platform.select('wm-hb-stdb-proper-prope-wrwjnnjs0u0y', 'wd-hb-stdb-proper-prope-7ik6mo0arbzn'),
    PDPright_desktop: platform.select('wd-hb-stdb-proper-prope-n0h1u70h5wvp', 'wd-hb-stdb-proper-prope-awt1tl5pyq9v'),
    PDPtop: platform.select('wm-hb-stdb-proper-prope-l8n03tul54wm', 'wm-hb-stdb-proper-prope-1ekmstrfsdgp'),
    PDPgallery_desktop: platform.select('wd-hb-stdb-proper-prope-g2sglmtgmlx2', 'wd-hb-stdb-proper-prope-ml4dxiqsdspy'),
    SRPbottom_desktop: platform.select('wd-hb-stdb-proper-prope-3zzm0houi6hw', 'wd-hb-stdb-proper-prope-pkixtslky3yp'),
    SRPbottom_mobile: platform.select('wm-hb-stdb-proper-prope-cn2tdvbprl3w', 'wm-hb-stdb-proper-prope-6exkewdzdlvy'),
    SRPmiddle_desktop: platform.select('wd-hb-stdb-proper-prope-31jcz3r8fvya', 'wd-hb-stdb-proper-prope-p2kat6hhk8i5'),
    SRPmiddle_mobile: platform.select('wm-hb-iart-proper-prope-1nk5vpqjyoxe', 'wm-hb-iart-proper-prope-zziwvw0ue3yf'),
    SRPright: platform.select('wd-hb-stdb-proper-prope-x0zn9fxg8y0v', 'wd-hb-stdb-proper-prope-0eifgkfzk3jp'),
    SRPrightbottom: platform.select('wd-hb-stdb-proper-prope-gylla34ydrfx', 'wd-hb-stdb-proper-prope-0vufx6gjujoy'),
    SRPstickyfooter: platform.select('wm-hb-stdb-proper-prope-2svag0nb7lt5', 'wm-hb-stdb-proper-prope-uaggcooceh55'),
    SRPtop_desktop: platform.select('wd-hb-stdb-proper-prope-fvm2ww47irsx', 'wd-hb-stdb-proper-prope-qapxxif0z5ey'),
    SRPtop_mobile: platform.select('wm-hb-iart-proper-prope-ewkrr7pauwkp', 'wm-hb-iart-proper-prope-uuqvrzgbv0y8'),
  },
};

export const PBJS_BLOCKED_DOMAINS = [
  'zoopla.co.uk',
  'zoopla.com',
  'onthemarket.com',
  'rightmove.co.uk',
  'homesni.com',
  'myhome.ie',
];

export const PBJS_CONFIG = {
  bidderSequence: 'random',
  enableSendAllBids: true,
  priceGranularity: 'auto',
  useBidCache: true,
  minBidCacheTTL: 0,
  enableTIDs: true,
  gvlMapping: {
    pairId: 755,
  },
  consentManagement: {
    gdpr: {
      cmpApi: 'iab',
      timeout: 8000,
      defaultGdprScope: true,
      rules: [
        {
          purpose: 'storage',
          enforcePurpose: true,
          enforceVendor: true,
          vendorExceptions: ['pubCommonId'],
        },
        {
          purpose: 'basicAds',
          enforcePurpose: true,
          enforceVendor: true,
        },
        {
          purpose: 'measurement',
          enforcePurpose: true,
          enforceVendor: true,
        },
      ],
    },
    usp: {
      timeout: 8000,
    },
    gpp: {
      cmpApi: 'iab',
      timeout: 8000,
    },
  },
  currency: {
    adServerCurrency: 'GBP',
  },
  rubicon: {
    singleRequest: true,
  },
  ix: {
    timeout: 500,
  },
  userSync: {
    iframeEnabled: true,
    filterSettings: {
      iframe: {
        bidders: ['ix', 'rubicon', 'sovrn', 'onetag', 'equativ'],
        filter: 'include',
      },
      image: {
        bidders: '*',
        filter: 'include',
      },
    },
    userIds: [
      {
        name: 'sharedId',
        storage: {
          type: 'cookie',
          name: '_sharedid',
          expires: 365,
        },
      },
      {
        name: 'identityLink',
        params: {
          pid: liveRampParams.placementId,
          notUse3P: false,
        },
        storage: {
          type: 'cookie',
          name: 'idl_env',
          expires: 15,
          refreshInSeconds: 1800,
        },
      },
      {
        name: 'pairId',
        params: {
          liveramp: {},
        },
      },
    ],
    syncsPerBidder: 5,
    syncDelay: 3000,
  },
  ortb2: {
    site: {
      name: platform.select('PropertyPal.com', 'Propertynews.com'),
      domain: platform.select('www.propertypal.com', 'www.propertynews.com'),
      cat: ['IAB21'],
      sectioncat: ['IAB21-3'],
      pagecat: ['IAB21-3'],
      language: 'en',
      mobile: 1,
      privacypolicy: 1,
      publisher: {
        name: 'PropertyPal.com Ltd',
        cat: ['IAB21'],
        domain: 'www.propertypal.com',
      },
      keywords: 'real estate, houses, apartments, property sales, property lettings, rentals',
    },
  },
};

export const BIDDER_CONFIGS = {};

const PB_CONFIG_BASE = [
  {
    bidder: 'rubicon',
    params: {
      accountId: rubiconParams.accountId,
      siteId: rubiconParams.siteId,
      zoneId: rubiconParams.zoneId,
    },
  },
  {
    bidder: 'unruly',
    params: {
      siteId: unrulyParams.siteId,
    },
  },
];

const PB_CONFIG_WIDE = [
  ...PB_CONFIG_BASE,
  {
    bidder: 'sharethrough',
    params: {
      pkey: 'pLZwbW7btD23n41UfKmbEaqQ',
    },
  },
];

const PB_CONFIG_BOX = [
  ...PB_CONFIG_BASE,
  {
    bidder: 'sharethrough',
    params: {
      pkey: 'ZNY2z8egwj8yACegji78CLzy',
    },
  },
];

const PB_CONFIG_SMALL = [
  ...PB_CONFIG_BASE,
  {
    bidder: 'sharethrough',
    params: {
      pkey: 'RUyogJDMEndzXAb3xGrkghyd',
    },
  },
];

const PB_CONFIG_TALL = [
  ...PB_CONFIG_BASE,
  {
    bidder: 'sharethrough',
    params: {
      pkey: 'N56CsVbYM28gWtCPm7N1ZX47',
    },
  },
];

const SOVRN_CONFIG = (tagid: number) => ({
  bidder: 'sovrn',
  params: { tagid },
});

const INMOBI_CONFIG = (placementId: string) => ({
  bidder: 'inmobi',
  params: { plc: placementId },
});

const IX_CONFIG = (siteId: string) => ({
  bidder: 'ix',
  params: { siteId },
});

const EQUATIV_CONFIG = (siteId = 772577, pageId = 2194761, formatId = 154303) => ({
  bidder: 'equativ',
  params: {
    networkId: 5680,
    siteId,
    pageId,
    formatId,
  },
});

const ONETAG_CONFIG = (placementName: string) => ({
  bidder: 'onetag',
  params: { pubId: '7cee6c8f60c9c71', ext: { ent_name: placementName || 'default' } },
});

const OGURY_CONFIG = (
  assetKey: string,
  adUnitId: string,
  adSlotSelector?: string,
  headerSelector?: string,
  adSlotSelectorPosition?: string,
  fixedElements?: ['string'],
) => ({
  bidder: 'ogury',
  params: {
    assetKey,
    adUnitId: oguryParams.adUnitIds[adUnitId],
    adSlotSelector,
    headerSelector,
    adSlotSelectorPosition,
    fixedElements,
  },
});

export const PREBID_UNIT_CONFIG = {
  SRPtop_desktop: [
    ...PB_CONFIG_WIDE,
    SOVRN_CONFIG(1239434),
    INMOBI_CONFIG(platform.select('10000476216', '10000476228')),
    IX_CONFIG('1294688'),
    ONETAG_CONFIG('SRPtop_desktop'),
    OGURY_CONFIG(oguryParams.assetKey, 'SRPtop_desktop'),
    EQUATIV_CONFIG(),
  ],
  SRPtop_mobile: [
    ...PB_CONFIG_BOX,
    SOVRN_CONFIG(1239435),
    INMOBI_CONFIG(platform.select('10000476225', '10000476228')),
    IX_CONFIG('1291337'),
    ONETAG_CONFIG('SRPtop_mobile'),
    OGURY_CONFIG(oguryParams.assetKey, 'SRPtop_mobile'),
    EQUATIV_CONFIG(),
  ],
  SRPright: [
    ...PB_CONFIG_BOX,
    SOVRN_CONFIG(1239431),
    INMOBI_CONFIG(platform.select('10000476219', '10000476234')),
    IX_CONFIG('1294689'),
    ONETAG_CONFIG('SRPright'),
    OGURY_CONFIG(oguryParams.assetKey, 'SRPright'),
    EQUATIV_CONFIG(),
  ],
  SRPrightbottom: [
    ...PB_CONFIG_TALL,
    SOVRN_CONFIG(1239430),
    INMOBI_CONFIG(platform.select('10000476220', '10000476235')),
    IX_CONFIG('1291336'),
    ONETAG_CONFIG('SRPrightbottom'),
    OGURY_CONFIG(oguryParams.assetKey, 'SRPrightbottom'),
    EQUATIV_CONFIG(),
  ],
  SRPmiddle_desktop: [
    ...PB_CONFIG_WIDE,
    SOVRN_CONFIG(1239440),
    INMOBI_CONFIG(platform.select('10000476218', '10000476230')),
    IX_CONFIG('1294690'),
    ONETAG_CONFIG('SRPmiddle_desktop'),
    EQUATIV_CONFIG(),
  ],
  SRPmiddle_mobile: [
    ...PB_CONFIG_SMALL,
    SOVRN_CONFIG(1239433),
    INMOBI_CONFIG(platform.select('10000476227', '10000476231')),
    IX_CONFIG('1294691'),
    ONETAG_CONFIG('SRPmiddle_mobile'),
    OGURY_CONFIG(oguryParams.assetKey, 'SRPmiddle_mobile', 'adunit-SRPmiddle_mobile'),
    EQUATIV_CONFIG(),
  ],
  SRPbottom_desktop: [
    ...PB_CONFIG_WIDE,
    SOVRN_CONFIG(1239436),
    INMOBI_CONFIG(platform.select('10000476218', '10000476232')),
    IX_CONFIG('1294692'),
    ONETAG_CONFIG('SRPbottom_desktop'),
    OGURY_CONFIG(oguryParams.assetKey, 'SRPbottom_desktop'),
    EQUATIV_CONFIG(),
  ],
  SRPbottom_mobile: [
    ...PB_CONFIG_BOX,
    SOVRN_CONFIG(1239441),
    INMOBI_CONFIG(platform.select('10000476227', '10000476233')),
    IX_CONFIG('1294693'),
    ONETAG_CONFIG('SRPbottom_mobile'),
    OGURY_CONFIG(oguryParams.assetKey, 'SRPbottom_mobile'),
    EQUATIV_CONFIG(),
  ],
  SRPstickyfooter: [
    ...PB_CONFIG_SMALL,
    SOVRN_CONFIG(1239438),
    INMOBI_CONFIG(platform.select('10000478437', '10000476246')),
    IX_CONFIG('1294694'),
    ONETAG_CONFIG('SRPstickyfooter'),
    OGURY_CONFIG(oguryParams.assetKey, 'SRPstickyfooter', '#sticky-footer-ad'),
    EQUATIV_CONFIG(),
  ],
  PDPtop: [
    ...PB_CONFIG_SMALL,
    SOVRN_CONFIG(1239439),
    INMOBI_CONFIG(platform.select('10000476221', '10000476236')),
    IX_CONFIG('1294695'),
    ONETAG_CONFIG('PDPtop'),
    OGURY_CONFIG(oguryParams.assetKey, 'PDPtop', 'adunit-PDPtop'),
    EQUATIV_CONFIG(),
  ],
  PDPmiddle_desktop: [
    ...PB_CONFIG_WIDE,
    SOVRN_CONFIG(1239442),
    INMOBI_CONFIG(platform.select('10000476222', '10000476237')),
    IX_CONFIG('1294696'),
    ONETAG_CONFIG('PDPmiddle_desktop'),
    OGURY_CONFIG(oguryParams.assetKey, 'PDPmiddle_desktop'),
    EQUATIV_CONFIG(),
  ],
  PDPmiddle_mobile: [
    ...PB_CONFIG_BOX,
    SOVRN_CONFIG(1239443),
    INMOBI_CONFIG(platform.select('10000476223', '10000476238')),
    IX_CONFIG('	1294697'),
    ONETAG_CONFIG('PDPmiddle_mobile'),
    OGURY_CONFIG(oguryParams.assetKey, 'PDPmiddle_mobile'),
    EQUATIV_CONFIG(),
  ],
  PDPgallery_desktop: [
    ...PB_CONFIG_TALL,
    SOVRN_CONFIG(platform.select(1305811, 1305812)),
    INMOBI_CONFIG(platform.select('10000628284', '10000628285')),
    IX_CONFIG('1325821'),
    ONETAG_CONFIG('PDPgallery_desktop'),
    OGURY_CONFIG(oguryParams.assetKey, 'PDPgallery_desktop'),
    EQUATIV_CONFIG(),
  ],
  PDPmap: [
    ...PB_CONFIG_SMALL,
    SOVRN_CONFIG(1239444),
    INMOBI_CONFIG(platform.select('10000478438', '10000478441')),
    IX_CONFIG('1291338'),
    ONETAG_CONFIG('PDPmap'),
    OGURY_CONFIG(oguryParams.assetKey, 'PDPmap'),
    EQUATIV_CONFIG(),
  ],
  PDPmediabox: [
    ...PB_CONFIG_SMALL,
    SOVRN_CONFIG(1239445),
    INMOBI_CONFIG(platform.select('10000478439', '10000478442')),
    IX_CONFIG('1291339'),
    ONETAG_CONFIG('PDPmediabox'),
    OGURY_CONFIG(oguryParams.assetKey, 'PDPmediabox'),
    EQUATIV_CONFIG(),
  ],
  PDPright_desktop: [
    ...PB_CONFIG_BOX,
    INMOBI_CONFIG(platform.select('10000476224', '10000476239')),
    IX_CONFIG('1291340'),
    ONETAG_CONFIG('PDPright_desktop'),
    OGURY_CONFIG(oguryParams.assetKey, 'PDPright_desktop'),
    EQUATIV_CONFIG(),
  ],
};
